import type {
  SiteConfig,
  SiteConfigBrand,
  SiteConfigProfile,
  SiteConfigStyle,
} from './types';
import { PLATFORM_PALETTE, brandPaletteToStyleColumns } from './colorRoles';

// ─────────────────────────────────────────────
// Style defaults — the color half comes from THE registry (colorRoles.ts's PLATFORM_PALETTE),
// which is also what api-gateway's PLATFORM_STYLE_DEFAULTS / SYSTEM_DEFAULTS and globals.css's
// :root now resolve to. This palette used to be written out in five places and had already
// drifted three ways on the muted grey alone.
// ─────────────────────────────────────────────

export const DEFAULT_STYLE: SiteConfigStyle = {
  ...(brandPaletteToStyleColumns(PLATFORM_PALETTE) as Pick<
    SiteConfigStyle,
    | 'color_primary'
    | 'color_secondary'
    | 'color_accent'
    | 'color_background'
    | 'color_surface'
    | 'color_text'
    | 'color_text_muted'
  >),
  heading_font:     'Montserrat, sans-serif',
  body_font:        'Rethink Sans, sans-serif',
  content_width:    '1280px',
  section_spacing:  '80px',
  border_radius:    '8px',
};

export const DEFAULT_BRAND: SiteConfigBrand = {
  company_name: 'My Real Estate',
  logo_url:     null,
  favicon_url:  null,
  tagline:      'Your trusted local real estate expert',
};

export const DEFAULT_PROFILE: SiteConfigProfile = {
  full_name:       'Agent Name',
  phone:           '(800) 555-0100',
  email:           'hello@myrealestate.com',
  headshot_url:    null,
  license_number:  '',
  license_state:   '',
  brokerage_name:  '',
  mls_id:          '',
  bio:             '',
  social: {
    instagram: null,
    facebook:  null,
    linkedin:  null,
    youtube:   null,
  },
};

// ─────────────────────────────────────────────
// Root default — returned for unknown / brand-new tenants
// ─────────────────────────────────────────────

export const DEFAULT_SITE_CONFIG: SiteConfig = {
  tenant_id:  '',
  slug:       '',
  plan:       'free',
  brand:      DEFAULT_BRAND,
  profile:    DEFAULT_PROFILE,
  style:      DEFAULT_STYLE,
  pages:      [],
  navigation: [],
  raw_build:  null,
  template:   null,
};
